/**
 * Import Dependency
 */
import { createAction } from 'redux-actions'
import {
  ADD_STASH_BY_OPTION_GROUP,
  REMOVE_STASH_BY_OPTION_GROUP,
  RESET_STASH_BY_OPTION_GROUP,
  ADD_STASH_BY_RADIO_GROUP,
  RESET_STASH_BY_RADIO_GROUP,
} from '../../constants/actionType'

/**
 * Declare Variable
 */
const addStashByOptionGroupsAction = createAction(ADD_STASH_BY_OPTION_GROUP)
const removeStashByOptionGroupsAction = createAction(REMOVE_STASH_BY_OPTION_GROUP)
const resetStashByOptionGroupsAction = createAction(RESET_STASH_BY_OPTION_GROUP)
const addStashByRadioGroupsAction = createAction(ADD_STASH_BY_RADIO_GROUP)
const resetStashByRadioGroupsAction = createAction(RESET_STASH_BY_RADIO_GROUP)

/**
 * Export
 */
export const addStashByOptionGroups = (params) => (dispatch) => {
  try {
    dispatch(addStashByOptionGroupsAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const removeStashByOptionGroups = (params) => (dispatch) => {
  try {
    dispatch(removeStashByOptionGroupsAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const resetStashByOptionGroups = () => (dispatch) => {
  try {
    dispatch(resetStashByOptionGroupsAction())
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const addStashByRadioGroups = (params) => (dispatch) => {
  try {
    dispatch(addStashByRadioGroupsAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const resetStashByRadioGroups = () => (dispatch) => {
  try {
    dispatch(resetStashByRadioGroupsAction())
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/actions/components/optionGroups.js